
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStockApproveDtDialog extends Serenity.EntityDialog<IcStockApproveDtRow, any> {
        protected getFormKey() { return IcStockApproveDtForm.formKey; }
        protected getIdProperty() { return IcStockApproveDtRow.idProperty; }
        protected getLocalTextPrefix() { return IcStockApproveDtRow.localTextPrefix; }
        protected getNameProperty() { return IcStockApproveDtRow.nameProperty; }
        protected getService() { return IcStockApproveDtService.baseUrl; }
        protected getDeletePermission() { return IcStockApproveDtRow.deletePermission; }
        protected getInsertPermission() { return IcStockApproveDtRow.insertPermission; }
        protected getUpdatePermission() { return IcStockApproveDtRow.updatePermission; }

        protected form = new IcStockApproveDtForm(this.idPrefix);
        
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);

            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();
                        // *** do something on click if you want **

                    },
                }
            );

            return buttons;
        }
        protected beforeLoadEntity() {
            let self = this;
            self.toolbar.findButton('save-and-close-button').text('บันทึกรายการ');
            self.toolbar.findButton('delete-button').text('ลบรายการ');

            let nbrRetry = 0;
            (function changeTitle() {
                if (nbrRetry >= 10) {
                    return;
                }

                setTimeout(() => {
                    if ((self as any).isMarkedAsPanel === true) {
                        if (self.element.find(".ui-dialog-title").length == 1) {
                            self.element.find(".ui-dialog-title").html("");
                            self.element.find(".ui-dialog-titlebar-text").html("");
                            self.element.find(".ui-dialog-titlebar-close").html("");//panel-titlebar
                        }
                        else {
                            changeTitle();
                        }
                    }
                    else {
                        if (self.element.parent().find(".ui-dialog-title").length == 1) {
                            self.element.parent().find(".ui-dialog-title").html("");
                            self.element.parent().find(".ui-dialog-titlebar-text").html("");
                            self.element.parent().find(".ui-dialog-titlebar-close").html("");
                        }
                        else {
                            changeTitle();
                        }
                    }
                }, 10);
            })();
        }
        protected afterLoadEntity() {
            super.afterLoadEntity();
            if (this.isEditMode){
                Serenity.EditorUtils.setReadonly(this.form.QtyCount.element, true);
            }
        }
         // protected getCssClass() {
        //     super.getCssClass();
        //     return "fixRight";

        // }
    }
}